import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { MenuSection } from './components/MenuSection';
import { Contact } from './components/Contact';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Menu',
    href: '#menu'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <div className="min-h-screen bg-neutral-50 font-sans selection:bg-red-600 selection:text-white" data-id="element-0">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-1' : 'bg-transparent py-3'}`} data-id="element-1">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-2">
          <a href="#home" className="flex items-center" data-id="element-3">
            <img src="https://cdn.magicpatterns.com/uploads/p4iFB11LgfkFspQDPPQpex/PizzaWarehouse-Logo.jpg" alt="Pizza Warehouse" className={`transition-all duration-300 ${isScrolled ? 'h-12' : 'h-14'}`} data-id="element-4" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-5">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`font-heading font-medium text-lg tracking-wide hover:text-red-600 transition-colors ${isScrolled ? 'text-neutral-800' : 'text-white drop-shadow-md'}`} data-id="element-6">
                {link.name}
              </a>)}
            <a href="tel:270-933-1035" className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-full font-heading font-bold tracking-wider transition-colors shadow-md" data-id="element-7">
              ORDER NOW
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 z-50 relative" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-8">
            {mobileMenuOpen ? <X className="text-black" size={28} data-id="element-9" /> : <Menu className={isScrolled ? 'text-black' : 'text-white'} size={28} data-id="element-10" />}
          </button>
        </div>

        {/* Mobile Nav Dropdown */}
        {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-neutral-100" data-id="element-11">
            <div className="flex flex-col items-center gap-4 py-6 px-4" data-id="element-12">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="font-heading font-medium text-xl text-neutral-800 hover:text-red-600 w-full text-center py-2" data-id="element-13">
                  {link.name}
                </a>)}
              <a href="tel:270-933-1035" className="bg-red-600 text-white px-8 py-3 rounded-full font-heading font-bold tracking-wider mt-2 w-full max-w-xs text-center" data-id="element-14">
                CALL TO ORDER
              </a>
            </div>
          </div>}
      </nav>

      <main data-id="element-15">
        <Hero data-id="element-16" />
        <MenuSection data-id="element-17" />
        <Contact data-id="element-18" />
      </main>
    </div>;
}